import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { NotebookPen, Trophy, CalendarDays, Bell, Map, Flame, Award, LayoutDashboard, Landmark, Clock } from "lucide-react";

export const Route = createFileRoute("/_authenticated/journey")({
  head: () => ({
    meta: [
      { title: "Your Journey · KAfrequency" },
      { name: "description", content: "Your personal path across the KAfrequency ecosystem — journal, challenges, calendar, notifications, and the Life Journey Map." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: JourneyLayout,
});

interface Tab { to: string; label: string; icon: typeof LayoutDashboard; exact?: boolean }
const TABS: Tab[] = [
  { to: "/journey", label: "Overview", icon: LayoutDashboard, exact: true },
  { to: "/journey/map", label: "Life Map", icon: Map },
  { to: "/journey/timeline", label: "Timeline", icon: Clock },
  { to: "/journey/temple", label: "Temple", icon: Landmark },
  { to: "/journey/challenges", label: "Challenges", icon: Flame },
  { to: "/journey/journal", label: "Journal", icon: NotebookPen },
  { to: "/journey/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/journey/notifications", label: "Notifications", icon: Bell },
  { to: "/journey/achievements", label: "Achievements", icon: Trophy },
  { to: "/journey/certificates", label: "Certificates", icon: Award },
];

function JourneyLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="min-h-dvh bg-obsidian text-foreground">
      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:px-8">
        <header className="mb-6">
          <h1 className="font-serif text-3xl text-gold-luminous sm:text-4xl">Your Journey</h1>
          <p className="mt-1 text-sm text-foreground/70">Everything personal to your path lives here — private by default.</p>
        </header>
        <nav aria-label="Journey sections" className="mb-8 overflow-x-auto">
          <ul className="flex min-w-max gap-1 border-b hairline">
            {TABS.map((t) => {
              const active = t.exact ? pathname === t.to : pathname === t.to || pathname.startsWith(t.to + "/");
              const Icon = t.icon;
              return (
                <li key={t.to}>
                  <Link
                    to={t.to as "/journey"}
                    className={`inline-flex items-center gap-2 border-b-2 px-3 py-2 text-sm transition-colors ${
                      active ? "border-gold text-gold-luminous" : "border-transparent text-foreground/70 hover:text-gold"
                    }`}
                  >
                    <Icon size={16} aria-hidden />
                    <span>{t.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
        <Outlet />
      </div>
    </div>
  );
}
